module.exports = __webpack_public_path__ + "static/media/ios-warning.c094c1c9.svg";